import { Reveal } from '@/components/motion';

export function Privacy() {
  return (
    <section className="pt-16 md:pt-24 pb-24" data-testid="privacy-page">
      <div className="container-x max-w-3xl">
        <Reveal>
          <div className="overline mb-6">Legal</div>
          <h1 className="h-display text-balance">Privacy Policy</h1>
          <p className="body-md mt-4">Last updated: {new Date().toLocaleDateString('en-AU', { year: 'numeric', month: 'long' })}</p>
        </Reveal>
        <div className="mt-14 space-y-8 prose prose-neutral max-w-none text-ink-soft">
          <p>Inclusive Mobility Group respects your privacy. This policy explains how we collect, use, hold, disclose and protect personal information in accordance with the Australian Privacy Principles under the Privacy Act 1988 (Cth) and the NDIS Practice Standards.</p>
          <h2 className="h-card !text-ink">Information we collect</h2>
          <p>We collect personal information you provide to us via bookings, quotes, enquiries and referral forms — including name, contact details, NDIS number, funding source, travel details and any relevant health, accessibility or support requirements.</p>
          <h2 className="h-card !text-ink">How we use your information</h2>
          <p>We use your information to deliver transport services, coordinate with support workers, aged care providers, hospital discharge teams and health services, and to communicate with you about bookings and services. We do not sell your data.</p>
          <h2 className="h-card !text-ink">Data storage &amp; security</h2>
          <p>Data is stored securely in Australian-hosted infrastructure with access controls, encryption in transit and audit logging. Access is limited to authorised staff on a need-to-know basis.</p>
          <h2 className="h-card !text-ink">Your rights</h2>
          <p>You can request access to your personal information, correct it, or ask us to delete it, subject to legal record-keeping obligations. Email hello@swiftcommunitytransport.com.au and we'll respond within 30 days.</p>
          <h2 className="h-card !text-ink">Complaints</h2>
          <p>If you believe we have breached your privacy, please contact our Privacy Officer at the email above. Unresolved complaints can be escalated to the Office of the Australian Information Commissioner (OAIC).</p>
        </div>
      </div>
    </section>
  );
}

export function Terms() {
  return (
    <section className="pt-16 md:pt-24 pb-24" data-testid="terms-page">
      <div className="container-x max-w-3xl">
        <Reveal>
          <div className="overline mb-6">Legal</div>
          <h1 className="h-display text-balance">Terms &amp; Conditions</h1>
          <p className="body-md mt-4">Last updated: {new Date().toLocaleDateString('en-AU', { year: 'numeric', month: 'long' })}</p>
        </Reveal>
        <div className="mt-14 space-y-8 prose prose-neutral max-w-none text-ink-soft">
          <p>These terms govern your use of Inclusive Mobility Group services. By booking a service or engaging with us, you accept these terms.</p>
          <h2 className="h-card !text-ink">1. Bookings</h2>
          <p>Bookings are confirmed once we notify you in writing (email, SMS or via a coordinator call). We reserve the right to reschedule due to safety, vehicle or driver constraints, and will always offer a suitable alternative.</p>
          <h2 className="h-card !text-ink">2. Cancellations</h2>
          <p>Cancellations more than 24 hours before pickup are free of charge. Cancellations within 24 hours may attract a fee consistent with the NDIS Price Guide (for NDIS trips) or standard commercial rates.</p>
          <h2 className="h-card !text-ink">3. Passenger conduct &amp; safety</h2>
          <p>All passengers must comply with driver directions on seatbelts, wheelchair restraints and vehicle safety. We reserve the right to end a trip if a passenger or accompanying party behaves unsafely.</p>
          <h2 className="h-card !text-ink">4. Payment</h2>
          <p>Invoices are issued within 7 days of trip completion. NDIS, TAC, WorkSafe and aged care claims are billed to the appropriate funder where authorised.</p>
          <h2 className="h-card !text-ink">5. Liability</h2>
          <p>Inclusive Mobility Group maintains comprehensive commercial passenger insurance and public liability cover. Our liability for any loss arising from the service is limited to the extent permitted by law.</p>
          <h2 className="h-card !text-ink">6. Contact</h2>
          <p>Questions about these terms? Email hello@swiftcommunitytransport.com.au or call our national office.</p>
        </div>
      </div>
    </section>
  );
}
